module.exports = __webpack_public_path__ + "static/media/turkey.22c8f3a5.png";